// src/components/StructuredData.client.tsx
import { useEffect, useState } from 'react';

const StructuredData = ({ context, type, id, data }) => {
  const [jsonLd, setJsonLd] = useState(null);

  useEffect(() => {
    if (data) {
      const structuredData = {
        '@context': context || 'https://schema.org',
        '@type': type,
        '@id': id,
        ...data,
      };
      setJsonLd(structuredData);
    }
  }, [context, type, id, data]);

  return jsonLd ? (
    <script type="application/ld+json">
      {JSON.stringify(jsonLd)}
    </script>
  ) : null;
};

export default StructuredData;